import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from 'react-loader';
import { Container } from 'reactstrap';
import Layout from '../components/Layout';
import PageNav from '../components/PageNav';
import { fetchAbouts } from '../modules/AboutList/actions';
import { isLoaded, getError } from '../modules/AboutList/reducer';
import AboutList from '../modules/AboutList';

class AboutListpage extends Component {
  componentDidMount() {
    this.props.fetchAbouts();
  }

  render() {
    const { isLoaded } = this.props;
    return (
      <Layout>
        <Container>
          <PageNav>
            <h1>O klinice</h1>
          </PageNav>
          <Loader loaded={isLoaded}>
            <AboutList />
          </Loader>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoaded: isLoaded(state),
    error: getError(state)
  };
};

export default connect(
  mapStateToProps,
  { fetchAbouts }
)(AboutListpage);



// WEBPACK FOOTER //
// ./src/pages/AboutListPage.js